import { OptionType } from "../components/customField/CustomField";
import { InvitationStatus } from "../components/exhibitorInvitations/statusOfSentInvitations/StatusOfSentInvitations";
import { TradeEvent } from "../services/api";
import { _AddedEvent, _NotyficationEveny, _TradeAwardsFair } from "../types/types";

export const mockInvitations: {
  id: number;
  fullName: string;
  email: string;
  status: InvitationStatus;
  reminder?: boolean;
}[] = [
  { id: 1, fullName: "Jan Kowalski", email: "jan.kowalski@example.com", status: "Wysłane" },
  { id: 2, fullName: "Anna Nowak", email: "anna.nowak@example.com", status: "Aktywowane"},
  { id: 3, fullName: "Piotr Wiśniewski", email: "piotr.wisniewski@example.com", status: "Potwierdzone", reminder: true },
  { id: 4, fullName: "Katarzyna Zielińska", email: "katarzyna.zielinska@example.com", status: "Wysłane" },
  { id: 5, fullName: "Michał Wójcik", email: "michal.wojcik@example.com", status: "Potwierdzone", reminder: false },
  { id: 6, fullName: "Agnieszka Kamińska", email: "agnieszka.kaminska@example.com", status: "Aktywowane", reminder: true },
  { id: 7, fullName: "Tomasz Lewandowski", email: "tomasz.lewandowski@example.com", status: "Wysłane" },
  { id: 8, fullName: "Magdalena Szymańska", email: "magda.szymanska@example.com", status: "Wysłane", reminder: true },
  { id: 9, fullName: "Paweł Woźniak", email: "pawel.wozniak@example.com", status: "Aktywowane", reminder: false },
  { id: 10, fullName: "Ewa Kozłowska", email: "ewa.kozlowska@example.com", status: "Potwierdzone", reminder: false },
  { id: 11, fullName: "Marcin Jankowski", email: "marcin.jankowski@example.com", status: "Wysłane"},
  { id: 12, fullName: "Joanna Mazur", email: "joanna.mazur@example.com", status: "Aktywowane", reminder: false },
  { id: 13, fullName: "Grzegorz Krawczyk", email: "grzegorz.krawczyk@example.com", status: "Potwierdzone", reminder: true },
  { id: 14, fullName: "Paulina Piotrowska", email: "paulina.piotrowska@example.com", status: "Wysłane", reminder: false }
];

export const sampleEvents: _AddedEvent[] = [
  {
    id: 1,
    exhibition_id: 101,
    name: 'Event 1',
    eventDate: '2025-09-01',
    startTime: '09:00',
    endTime: '12:00',
    eventType: 'Montaż stoiska',
    eventTitle: 'Konferencja branżowa',
    description: 'Opis konferencji dotyczącej nowych technologii.',
    organizer: 'Organizator A',
    addedToOfficialCatalog: false,
  },
  {
    id: 2,
    exhibition_id: 102,
    name: 'Event 2',
    eventDate: '2025-09-02',
    startTime: '10:00',
    endTime: '14:00',
    eventType: 'Demontaż stoiska',
    eventTitle: 'Warsztaty programistyczne',
    description: 'Ogólnie znana teza ...',
    organizer: 'Organizator B',
    isDelete: false,
    isEdited: false,
  },
  {
    id: 3,
    exhibition_id: 103,
    name: 'Event 3',
    eventDate: '2025-09-03',
    startTime: '11:00',
    endTime: '15:00',
    eventType: 'Prezentacja produktów i marek',
    eventTitle: 'Wystawa sztuki nowoczesnej',
    description: 'Ogólnie znana teza ...',
    organizer: 'Organizator C',
    addedToOfficialCatalog: true,
  },
  {
    id: 4,
    exhibition_id: 104,
    name: 'Event 4',
    eventDate: '2025-09-04',
    startTime: '13:00',
    endTime: '17:00',
    eventType: 'Edukacyjne i eksperckie',
    eventTitle: '',
    description: 'Pokaz nowego urządzenia elektronicznego.',
    organizer: 'Organizator D',
    isDelete: true,
    isEdited: true,
  },
  {
    id: 5,
    exhibition_id: 105,
    name: 'Event 5',
    eventDate: '2025-09-05',
    startTime: '08:30',
    endTime: '11:30',
    eventType: 'Dostawa i montaż sprzętu/materiałów',
    eventTitle: 'Seminarium naukowe',
    description: 'Wykłady specjalistów z branży medycznej.',
    organizer: 'Organizator E',
    addedToOfficialCatalog: false,
  },
  {
    id: 6,
    exhibition_id: 106,
    name: 'Event 6',
    eventDate: '2025-09-06',
    startTime: '15:00',
    endTime: '18:00',
    eventType: 'Montaż stoiska',
    eventTitle: 'Warsztaty kreatywnego pisania',
    description: 'Zajęcia z pisania literackiego i storytellingu.',
    organizer: 'Organizator F',
    isDelete: false,
    isEdited: false,
  },
  {
    id: 7,
    exhibition_id: 107,
    name: 'Event 7',
    eventDate: '2025-09-07',
    startTime: '09:30',
    endTime: '11:30',
    eventType: 'Demontaż stoiska',
    eventTitle: 'Spotkanie networkingowe',
    description: 'Networking branżowy dla profesjonalistów.',
    organizer: 'Organizator G',
    addedToOfficialCatalog: true,
  },
  {
    id: 8,
    exhibition_id: 108,
    name: 'Event 8',
    eventDate: '2025-09-08',
    startTime: '12:00',
    endTime: '14:00',
    eventType: 'Prezentacja produktów i marek',
    eventTitle: 'Prezentacja nowej kolekcji',
    description: 'Wydarzenie prezentujące nową linię produktów.',
    organizer: 'Organizator H',
    isDelete: true,
    isEdited: false,
  },
  {
    id: 9,
    exhibition_id: 109,
    name: 'Event 9',
    eventDate: '2025-09-09',
    startTime: '10:00',
    endTime: '16:00',
    eventType: 'Edukacyjne i eksperckie',
    eventTitle: 'Seminarium edukacyjne',
    description: 'Edukacja na temat najnowszych trendów technologicznych.',
    organizer: 'Organizator I',
    addedToOfficialCatalog: false,
  },
  {
    id: 10,
    exhibition_id: 110,
    name: 'Event 10',
    eventDate: '2025-09-10',
    startTime: '09:00',
    endTime: '12:00',
    eventType: 'Dostawa i montaż sprzętu/materiałów',
    eventTitle: 'Logistyka wydarzenia',
    description: 'Koordynacja dostaw i montażu sprzętu.',
    organizer: 'Organizator J',
    isDelete: true,
    isEdited: true,
  },
  {
    id: 11,
    exhibition_id: 111,
    name: 'Event 11',
    eventDate: '2025-09-11',
    startTime: '13:00',
    endTime: '15:00',
    eventType: 'Montaż stoiska',
    eventTitle: 'Prezentacja produktu',
    description: 'Demonstracja produktu na stoisku.',
    organizer: 'Organizator K',
    addedToOfficialCatalog: false,
  },
  {
    id: 12,
    exhibition_id: 112,
    name: 'Event 12',
    eventDate: '2025-09-12',
    startTime: '14:00',
    endTime: '17:00',
    eventType: 'Demontaż stoiska',
    eventTitle: 'Zakończenie wystawy',
    description: 'Procedury demontażu i zakończenia wydarzenia.',
    organizer: 'Organizator L',
    isDelete: false,
    isEdited: false,
  },
  {
    id: 13,
    exhibition_id: 113,
    name: 'Event 13',
    eventDate: '2025-09-13',
    startTime: '09:00',
    endTime: '13:00',
    eventType: 'Prezentacja produktów i marek',
    eventTitle: 'Promocja produktów',
    description: 'Warsztaty promocyjne i marketingowe.',
    organizer: 'Organizator M',
    addedToOfficialCatalog: true,
  },
  {
    id: 14,
    exhibition_id: 114,
    name: 'Event 14',
    eventDate: '2025-09-14',
    startTime: '10:00',
    endTime: '12:00',
    eventType: 'Edukacyjne i eksperckie',
    eventTitle: 'Szkolenie specjalistyczne',
    description: 'Program szkoleniowy dla ekspertów branżowych.',
    organizer: 'Organizator N',
    isDelete: true,
    isEdited: false,
  },
  {
    id: 15,
    exhibition_id: 115,
    name: 'Event 15',
    eventDate: '2025-09-15',
    startTime: '11:00',
    endTime: '15:00',
    eventType: 'Dostawa i montaż sprzętu/materiałów',
    eventTitle: 'Koordynacja techniczna',
    description: 'Zarządzanie dostawą i montażem materiałów.',
    organizer: 'Organizator O',
    addedToOfficialCatalog: false,
  },
];

export const samplrTradeAwardsFair:_TradeAwardsFair[]=[
  {
    id: 1,
    message: "ASTOR jest produktem targowym..."
  },
  {
    id: 2,
    message: "Wyróżnienie za innowacyjny produkt"
  },
];

export const fieldOptions: OptionType[] = [
  { value: 'all', label: 'Wszystkie' },
  { value: 'house', label: 'Dom' },
  { value: 'reaEstate', label: 'Nieruchomości' },
  { value: 'garden', label: 'Ogród' },
  { value: 'other', label: 'Inne' },
];

export const buildDaysOption: OptionType[] = [
  { value: 'indywidualny', label: 'Montaż indywidualny' },
  { value: 'systemowy', label: 'Montaż systemowy' },
  { value: 'ptak_warsaw_expo', label: 'Zabudowa Targowa Ptak Warsaw Expo' },
];

export const invitationOptions:OptionType[]=[
  { value: 'standard', label: 'Standardowe' },
  { value: 'exhibitore', label: 'Dla wystawców' },
  { value: 'guest', label: 'Dla gości' },
  { value: 'vip', label: 'VIP' },
];
export const groupReceivingNotification:OptionType[]=[
  { value: 'standard', label: 'Standardowe' },
  { value: 'exhibitore', label: 'Dla wystawców' },
  { value: 'guest', label: 'Dla gości' },
  { value: 'vip', label: 'VIP' },
  { value: 'all', label: 'Wszyscy' },
  { value: 'biznes_priority', label: 'Biznes Priority' },
];
export const specialOffersOptions:OptionType[]=[
  { value: 'fastTrack', label: '🚀 Fast Track – szybkie wejście bez kolejki' },
  { value: 'personalizedPackage', label: '📦 Imienny pakiet – dostarczony przed wydarzeniem' },
  { value: 'welcomPack', label: '🎁 Welcome Pack z upominkiem' },
  { value: 'accessToConferencesAndWorkshops', label: '🎤 Dostęp do konferencji i warsztatów' },
  { value: 'FreeparkingAndConciergrService', label: ` 🤝 Darmowy parking i opiekę concierge`},
];


export const tradeEventsMock: TradeEvent[] = [
  {
    id: 1,
    exhibition_id: 101,
    exhibitor_id: 201,
    name: 'Ceremonia Otwarcia',
    eventDate: '2025-06-02',
    startTime: '09:00',
    endTime: '10:30',
    hall: 'Hala A',
    description: 'Uroczyste otwarcie targów',
    type: 'Ceremonia otwarcia',
    organizer: 'Organizator 1',
    link: 'https://example.com/event1',
  },
  {
    id: 2,
    exhibition_id: 101,
    exhibitor_id: 202,
    name: 'Główna Konferencja',
    eventDate: '2025-06-03',
    startTime: '11:00',
    endTime: '13:00',
    hall: 'Hala B',
    description: 'Prezentacje i wykłady branżowe',
    type: 'Konferencja',
    organizer: 'Organizator 2',
    link: 'https://example.com/event2',
  },
  {
    id: 3,
    exhibition_id: 101,
    exhibitor_id: 203,
    name: 'Panel Dyskusyjny',
    eventDate: '2025-06-04',
    startTime: '14:00',
    endTime: '15:30',
    hall: 'Hala C',
    description: 'Dyskusje panelowe z ekspertami',
    type: 'Panel dyskusyjny',
    organizer: 'Organizator 3',
    link: 'https://example.com/event3',
  },
    {
    id: 4,
    exhibition_id: 101,
    exhibitor_id: 203,
    name: 'Panel Dyskusyjny',
    eventDate: '2025-06-04',
    startTime: '14:00',
    endTime: '15:30',
    hall: 'Hala C',
    description: 'Dyskusje panelowe z ekspertami',
    type: 'Panel dyskusyjny',
    organizer: 'Organizator 3',
    link: 'https://example.com/event3',
  },
    {
    id: 5,
    exhibition_id: 101,
    exhibitor_id: 203,
    name: 'Panel Dyskusyjny',
    eventDate: '2025-06-04',
    startTime: '14:00',
    endTime: '15:30',
    hall: 'Hala C',
    description: 'Dyskusje panelowe z ekspertami',
    type: 'Panel dyskusyjny',
    organizer: 'Organizator 3',
    link: 'https://example.com/event3',
  },
    {
    id: 6,
    exhibition_id: 101,
    exhibitor_id: 203,
    name: 'Panel Dyskusyjny',
    eventDate: '2025-06-04',
    startTime: '14:00',
    endTime: '15:30',
    hall: 'Hala C',
    description: 'Dyskusje panelowe z ekspertami',
    type: 'Panel dyskusyjny',
    organizer: 'Organizator 3',
    link: '',
  },
];

export const notificationsMock: _NotyficationEveny[] = [
  {
    id: 1,
    eventId: 'E1001',
    date: '2025-09-10',
    startTime: '09:00',
    description: 'Otwarcie targów',
    receivers: 'all',
  },
  {
    id: 2,
    eventId: 'E1002',
    date: '2025-09-10',
    startTime: '11:00',
    description: 'Panel dyskusyjny VIP',
    receivers: 'vip',
  },
  {
    id: 3,
    eventId: 'E1003',
    date: '2025-09-11',
    startTime: '14:00',
    description: 'Prezentacja nowych produktów',
    receivers: 'exhibitore',
  },
  {
    id: 4,
    eventId: 'E1004',
    date: '2025-09-12',
    startTime: '13:00',
    description: 'Przerwa kawowa',
    receivers: 'all',
  },
  {
    id: 5,
    eventId: 'E1005',
    date: '2025-09-12',
    startTime: '15:00',
    description: 'Spotkanie z inwestorami',
    receivers: 'biznes_priority',
  },
  {
    id: 6,
    eventId: 'E1006',
    date: '2025-09-13',
    startTime: '10:00',
    description: 'Warsztaty dla wystawców',
    receivers: 'exhibitore',
  },
  {
    id: 7,
    eventId: 'E1007',
    date: '2025-09-13',
    startTime: '16:00',
    description: 'Sesja networkingowa',
    receivers: 'guest',
  },
  {
    id: 8,
    eventId: 'E1008',
    date: '2025-09-14',
    startTime: '09:30',
    description: 'Otwarcie stoiska biznesowego',
    receivers: 'biznes_priority',
  },
  {
    id: 9,
    eventId: 'E1009',
    date: '2025-09-14',
    startTime: '12:00',
    description: 'Panel dyskusyjny standard',
    receivers: 'standard',
  },
  {
    id: 10,
    eventId: 'E1010',
    date: '2025-09-15',
    startTime: '11:30',
    description: 'Zamknięcie wydarzenia',
    receivers: 'all',
  },
];